// Bare Gorgias account host; the gateway builds https://<domain> from it, so nothing else may pass.
export const GORGIAS_DOMAIN_PATTERN = /^[a-z0-9-]+\.gorgias\.com$/;

// Accepts pasted forms like "https://Store.gorgias.com/app/tickets" and returns "store.gorgias.com".
export const normalizeGorgiasDomain = (input: string): string =>
  input
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/[/?#].*$/, '');

export const isGorgiasDomain = (domain: string): boolean => GORGIAS_DOMAIN_PATTERN.test(domain);
